import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class QrCode extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { chQrCode, isHitBlack, searchPath } = content;

        const chQrcodeList = [
            {
                chNum: 14,
                chName: '凤凰军事',
                branchPic: 'millBrandPic',
                branchUrl: 'millBrandUrl',
            },
            {
                chNum: 3,
                chName: '凤凰资讯',
                branchPic: 'newsBrandPic',
                branchUrl: 'newsBrandUrl',
            },
            {
                chNum: 5,
                chName: '凤凰科技',
                branchPic: 'techBrandPic',
                branchUrl: 'techBrandUrl',
            },
            {
                chNum: 1,
                chName: '凤凰财经',
                branchPic: 'financeBrandPic',
                branchUrl: 'financeBrandUrl',
            },
            {
                chNum: 11,
                chName: '凤凰体育',
                branchPic: 'sportsBrandPic',
                branchUrl: 'sportsBrandUrl',
            },
            {
                chNum: 4,
                chName: '凤凰娱乐',
                branchPic: 'entBrandPic',
                branchUrl: 'entBrandUrl',
            },
            {
                chNum: 275736,
                chName: '凤凰卫视',
                branchPic: 'tvBrandPic',
                branchUrl: 'tvBrandUrl',
            },
        ];
        const liveChNum = (searchPath && searchPath.split('-') && searchPath.split('-')[0]) || '';
        let branchPic = '';
        let branchUrl = '';

        chQrcodeList.forEach(item => {
            if (liveChNum && item.chNum === parseInt(liveChNum)) {
                branchPic = chQrCode[item.branchPic] || '';
                branchUrl = chQrCode[item.branchUrl] || '';
            }
        });

        if (isHitBlack || !branchPic) {
            branchPic =
                chQrCode.defaultBrandPic ||
                'https://x0.ifengimg.com/ucms/2021_42/1A1FBF7564268C2D097B7C1AB8F7FE95FB07BCC7_size14_w640_h92.jpg';
            branchUrl = chQrCode.defaultBrandUrl || '#';
        }

        return (
            <div className={styles.qr_box}>
                <a target="_blank" href={branchUrl}>
                    <img src={branchPic} alt="二维码" />
                </a>
            </div>
        );
    }
}

export default errorBoundary(QrCode);
